"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AbstractElement = _interopRequireDefault(require("./AbstractElement"));

var _TextElementConstants = require("./TextElementConstants");

var getClasses = function getClasses(className, disabled, use, weight) {
  return (0, _classnames.default)(className, disabled ? 'is--text--disabled' : {
    'is--text--regular': weight === _TextElementConstants.WEIGHTS.regular,
    'is--text--medium': weight === _TextElementConstants.WEIGHTS.medium,
    'is--text--demibold': weight === _TextElementConstants.WEIGHTS.demi,
    'is--text--bold': weight === _TextElementConstants.WEIGHTS.bold,
    'is--text--error': use === _TextElementConstants.USES.error,
    'is--text--help': use === _TextElementConstants.USES.help,
    'is--text--success': use === _TextElementConstants.USES.success
  });
};

function AbstractTextElement(props) {
  var className = props.className,
      disabled = props.disabled,
      use = props.use,
      weight = props.weight,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "disabled", "use", "weight"]);
  return _react.default.createElement(_AbstractElement.default, (0, _extends2.default)({}, rest, {
    className: getClasses(className, disabled, use, weight)
  }));
}

AbstractTextElement.propTypes = (0, _extends2.default)({}, _AbstractElement.default.propTypes, {
  use: _propTypes.default.oneOf(Object.keys(_TextElementConstants.USES)),
  weight: _propTypes.default.oneOf(Object.keys(_TextElementConstants.WEIGHTS))
});
AbstractTextElement.defaultProps = _AbstractElement.default.defaultProps;
AbstractTextElement.displayName = 'AbstractTextElement';
var _default = AbstractTextElement;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/elements/AbstractTextElement.js
// module id = 316
// module chunks = 5 6